export enum IssueType {
  NO_DEVICES,
  MOTION_MASTER_DEINITIALIZED,
  MOTION_MASTER_WAITING_FOR_SLAVES,
}

export interface Issue {
  body: string;
  title: string;
  image: string;
}

export const issues: Map<number, Issue> = new Map<number, Issue>();

issues.set(IssueType.NO_DEVICES, {
  body: 'Please ensure that your devices are connected',
  image: 'question.svg',
  title: 'No devices attached',
});

issues.set(IssueType.MOTION_MASTER_DEINITIALIZED, {
  body: 'Please ensure that your devices are connected',
  image: 'disconnected.svg',
  title: 'Cannot find any devices',
});

issues.set(IssueType.MOTION_MASTER_WAITING_FOR_SLAVES, {
  body: 'Please connect and power on your devices',
  image: 'question.svg',
  title: 'Waiting for devices',
});
